export default "__VITE_ASSET__Qtr6wTLs__"